// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1_gUi","rootSmall":"AddTileButton_rootSmall__3qAmR"};